import { render, staticRenderFns } from "./goodsSearch.vue?vue&type=template&id=74de55ac&"
import script from "./goodsSearch.vue?vue&type=script&lang=js&"
export * from "./goodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./goodsSearch.vue?vue&type=style&index=0&id=74de55ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports